// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleDeploymentManager = {
  id: "deployment-manager",
  mrn: "//iam.api.mondoo.app/roles/deployment-manager",
  title: "Deployment Manager",
  allowedActions,
} as const;

export type RoleDeploymentManager = typeof roleDeploymentManager;
